/**
 * ==================================================================================
 * Date picker helper specifically for the Vue Functional Calendar
 * (https://github.com/Digital-Threads/vue-functional-calendar#readme)
 * ==================================================================================
 **/

import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
// import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import { FunctionalCalendar } from 'vue-functional-calendar'

export default {
  components: {
    'date-picker': FunctionalCalendar
  },
  data: function() {
    return {
      datepickerValue: {},
      datepickerFormat: 'mm/dd/yyyy',
      datepickerBeforeToday: ['beforeToday'],
      /**
       * !@WARNING: Format on the date picker's documentations
       * says '31/10/2019' but really is '10/31/2019'
       */
      datepickerBirthLimit: {
        min: dayjs()
          .subtract(100, 'year')
          .format('MM/DD/YYYY'),
        max: dayjs()
          .subtract(18, 'year')
          .format('MM/DD/YYYY')
      },
      datepickerCurrentDate: new Date(
        dayjs()
          .subtract(18, 'year')
          .format()
      )
    }
  },

  methods: {
    showDatepicker(bool, ref = 'datepicker') {
      if (bool) {
        this.$refs[ref].onFocusIn()
      } else {
        this.$refs[ref].onFocusOut(this.$refs[ref].$el)
      }
    },

    isSameOrBefore(to, from) {
      if (!to || !from) return
      if (dayjs(to).isSameOrBefore(dayjs(from))) return true
      return false
    }
  },
  created() {
    dayjs.extend(isSameOrBefore)
  }
}
